import React, { useEffect } from "react";
import { Box, CircularProgress, Typography } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import useFetchWithAuth from "../../../features/hooks/useFetchWithAuth";
import Layout from "../Layout";

function ScriptsDetailsSupervisor() {
  const { scriptId } = useParams();
  const navigate = useNavigate();

  const { data, loading, error } = useFetchWithAuth(
    `/scripts/products/${scriptId}/`
  );

  useEffect(() => {
    if (!data) return;
    if (!data.crm || !data.product_id) return;

    navigate(
      `/supervisor/script-templates/edit?kind=client_card&crm=${encodeURIComponent(
        data.crm
      )}&product_id=${encodeURIComponent(data.product_id)}`,
      { replace: true }
    );
  }, [data, navigate]);

  return (
    <Layout>
      <Box sx={{ p: 3 }}>
        {loading && <CircularProgress />}
        {!loading && error && (
          <Typography color="error">
            Помилка завантаження товару: {error.message}
          </Typography>
        )}
        {!loading && !error && data && (!data.crm || !data.product_id) && (
          <Typography color="text.secondary">
            Немає CRM або product_id для цього товару.
          </Typography>
        )}
      </Box>
    </Layout>
  );
}

export default ScriptsDetailsSupervisor;
